
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-slots",
      function () {
        return require("private-next-pages/event-slots/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-slots"])
      });
    }
  